import { render, staticRenderFns } from "./result-page.vue?vue&type=template&id=31a8b5f4&scoped=true&"
import script from "./result-page.vue?vue&type=script&lang=ts&"
export * from "./result-page.vue?vue&type=script&lang=ts&"
import style0 from "./result-page.vue?vue&type=style&index=0&id=31a8b5f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8b5f4",
  null
  
)

export default component.exports